import React, { Fragment, useState } from "react";
import styles from "./index.module.scss";
import {
  space_customize_purpose,
  space_flow,
  customizeExamples
} from "@/config/config";
import SampleSwiper from "./components/SampleSwiper";

export default function Index() {
  const [ index, setIndex ] = useState(0);

  return (
    <div>
      <section className={`${styles.banner} ${styles.top_banner}`}>
        <img
          className={styles.banner_img}
          src="/images/top_banner.jpg"
          alt="banner"
        />
      </section>
      <section className={styles.advantage_container}>
        <section className={styles.left_img}>
          <img alt="" src="/images/customization/customize_left.png" />
        </section>
        <section className={styles.advantage}>
          <div className={styles.desc}>
            雅集尚简，产品以适用为上，在茶空间项目中，雅集同样遵循实用的原则。公司目前承接企业、线下店、个人茶室的定制，且不限空间大小和风格要求。通过茶空间的搭建，雅集希望让普通人也能轻易感受到茶文化的魅力。在茶的和静清寂中，将浮华隔绝在外，早日寻得心中的“桃花源”。
          </div>
        </section>
        <section className={styles.right_img}>
          <img alt="" src="/images/customization/customize_right.png" />
        </section>
      </section>
      <section className={styles.purpose_wrapper}>
        <section className={styles.purpose_container}>
          {space_customize_purpose.map(item => (
            <section className={styles.purpose_content}>
              <div className={styles.title}>{item.title}</div>
              <div className={styles.desc}>{item.desc}</div>
            </section>
          ))}
        </section>
      </section>
      <section className={styles.flow_container}>
        <div className={styles.title}>定制流程</div>
        {space_flow.map((item, index) => (
          <Fragment>
            <div className={styles.text}>{item.title}</div>
            {index < space_flow.length - 1 ? (
              <img
                alt=""
                className={styles.circle}
                src="/images/customization/circle.png"
              />
            ) : null}
          </Fragment>
        ))}
      </section>
      <section className={styles.customize_example}>
        <div className={styles.customize_wrapper}>
          <div className={styles.title}>
            <span>定制案例</span>
          </div>
          <div className={styles.examples}>
            <ul className={styles.tabs}>
              {customizeExamples.map((item, idx) => (
                <li key={idx} onClick={() => setIndex(idx)} className={`${styles.tab} ${idx === Number(index) ? styles.current : ''}`}>
                  {item.title}
                </li>
              ))}
            </ul>
            <ul className={styles.content}>
            {customizeExamples.map((item, idx) => (
              <li key={idx} onClick={() => setIndex(idx)} className={idx === Number(index) ? styles.current : ''}>
                <SampleSwiper data={item.data} />
              </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <div className={styles.app_footer}>
        <div className={styles.app_img_container}>
          <img src="/images/logo.png" alt=""/>
        </div>
        <div className={styles.app_info_container}>
          <div className={styles.app_info}>
            <div>杭州雅集茶具有限公司</div>
            <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
          </div>
          <div className={styles.app_info}>
            <div>雅集专线:0571-86551555</div>
            <div>浙公网安备 33010802004971号</div>
          </div>
        </div>
      </div>
    </div>
  );
}
